export default {
    // 透传方法，参数不做任何处理
	transparent(method: String, params: any) {
		const config = this.config;
        const { loginIp, userCode } = config;
        return this.postMessage(method, {
			loginIp,
			userCode,
			params: params
		});
    }
}